import { z } from 'zod';

export const publicInquirySchema = z.object({
  firstName: z.string().trim().min(1, 'First name is required').max(100),
  lastName: z.string().trim().min(1, 'Last name is required').max(100),
  email: z.string().trim().email('Enter a valid email address').optional().or(z.literal('')),
  phone: z.string().trim().min(1, 'Phone number is required').max(30),
  countryOfInterest: z.string().trim().max(100).optional().or(z.literal('')),
  courseOfInterest: z.string().trim().max(150).optional().or(z.literal('')),
  message: z.string().trim().max(2000).optional().or(z.literal('')),
  website: z.string().optional().or(z.literal('')),
});

export type PublicInquiryFormValues = z.infer<typeof publicInquirySchema>;
